import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'app/design/primitives/box';
import { DocumentAttachment } from 'app/shopify/components/forms/DocumentAttachment';
import { Modal } from 'app/design/primitives/modal';
import { getLoanFeeDocumentName } from 'app/lib/loan-fee-document';

export function LoanFeeDocumentPreview({ url }: { url: string }) {
  const { t } = useTranslation('loanFee');
  const [open, setOpen] = useState(false);
  const name = getLoanFeeDocumentName(url);
  return (
    <>
      <DocumentAttachment
        name={name}
        previewLabel={t('document.view')}
        previewAccessibilityLabel={t('document.preview', { name })}
        onPreview={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
      />
      <Modal open={open} onClose={() => setOpen(false)} transparent>
        <Column
          backgroundColor="surface.default"
          borderRadius="radius.lg"
          padding="spacing.general.x4"
          gap="spacing.general.x4"
          width="95%"
          maxWidth={1000}
          height="90%"
        >
          <Modal.Title allowClose onClose={() => setOpen(false)}>
            {name}
          </Modal.Title>
          {/\.(png|jpe?g)$/i.test(name) ? (
            <img src={url} alt={name} style={{ width: '100%', flex: 1, minHeight: 0, objectFit: 'contain' }} />
          ) : (
            <iframe src={url} title={name} style={{ width: '100%', flex: 1, border: 0 }} />
          )}
          <a href={url} target="_blank" rel="noopener noreferrer">
            {t('document.open')}
          </a>
        </Column>
      </Modal>
    </>
  );
}
